import { render } from "./DadosCad.vue?vue&type=template&id=73518270&scoped=true"
import script from "./DadosCad.vue?vue&type=script&lang=js"
export * from "./DadosCad.vue?vue&type=script&lang=js"

import "./DadosCad.vue?vue&type=style&index=0&id=73518270&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73518270"]])

export default __exports__